var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "width": "640px",
      "max-height": "125",
      "height": "125",
      "align": "center",
      "color": _vm.$vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4',
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.uploader.click();
      }
    }
  }, [_c('v-card-text', {
    attrs: {
      "align": "center"
    }
  }, [!_vm.isLoading ? _c('div', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.iconColor
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _c('br'), _c('br'), _vm._v(" " + _vm._s(_vm.displayText) + " "), _c('br'), _c('br')], 1) : _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "70"
    }
  })], 1)], 1), _c('input', {
    ref: "uploader",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "file",
      "type": "file",
      "accept": "image/x-png,image/jpeg,image/jpg,.jpg,.jpeg,.png"
    },
    on: {
      "change": _vm.onFileInputEvent
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }